import axios from 'axios';
import { Modal } from 'antd';

import Config from '../config/config';
import Security from '../helpers/security';

const openModal = () => {
  Modal.error({
    title: 'Permission denied',
    content: 'Maybe you lost your session, try logging in again.',
    onOk: () => {
      Security.clear();
      window.location = '/';
    },
  });
};

const handleRequest = (req, interceptUnauhtorized) => {
  if (!Security.getToken() && !!interceptUnauhtorized) {
    openModal();
    return new Promise((resolve, reject) => {
      reject();
    });
  }

  const instance = axios.create({
    baseURL: Config.base_url,
    headers: {
      Authorization: `bearer ${Security.getToken()}`,
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: req.params || {},
    withCredentials: true,
  });

  return new Promise((resolve, reject) => {
    instance.request(req).then(
      (result) => resolve(result),
      (result) => {
        if (!!interceptUnauhtorized && result.response) { // intercept when session dies
          if (result.response.status === 401) {
            openModal();
          }

          if (result.response.status === 403) { // intercept when session dies
            window.location = '/403';
          }
        }

        reject(result);
      },
    );
  });
};

export { handleRequest };
